import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var drawer = createMultiStyleConfigHelpers(["dialog", "header", "body", "footer"]);
var drawerMenu = drawer.defineMultiStyleConfig({
    baseStyle: {
        dialog: {
            bg: 'neutrals.100',
            boxShadow: 'shadow-low'
        },
        header: {
            p: '16px 16px 4px 16px'
        },
        body: {
            p: "0 16px",
        },
        footer: {
            p: '16px'
        }
    }
});
var drawerTheme = drawerMenu;

export { drawerTheme };
//# sourceMappingURL=drawer.js.map
